export default "__VITE_ASSET__DzsBr_VK__"